import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  name: [
    {...makeRule()},
  ],
}

export let formRules = {}



// WEBPACK FOOTER //
// ./src/views/platform-user-province/platform-user-province.rules.js